import {TranslatedEmb} from '../../../../allkey/locale/message/TranslatedEmb';

export class Decision {
flowCode: string;
label: TranslatedEmb;
parentCode: string;
}

